import { __ } from "@wordpress/i18n";

export const TONES = [
    {
        tone: "casual",
        label: __("Casual", "antimanual"),
        description: __(
            "Use a relaxed and friendly tone. Keep the language simple and conversational, as if explaining to a beginner or a non-technical reader.",
            "antimanual"
        ),
    },
    {
        tone: "professional",
        label: __("Professional", "antimanual"),
        description: __(
            "Use clear, concise, and formal language. Maintain a professional tone suitable for business or corporate documentation.",
            "antimanual"
        ),
    },
    {
        tone: "technical",
        label: __("Technical", "antimanual"),
        description: __(
            "Use precise and detailed language appropriate for developers and technical users. Include accurate terminology and avoid unnecessary simplifications.",
            "antimanual"
        ),
    },
    {
        tone: "beginner-friendly",
        label: __("Beginner-friendly", "antimanual"),
        description: __(
            "Use very simple and clear language. Avoid jargon and assume the reader is new to the topic. Explain concepts in layman's terms.",
            "antimanual"
        ),
    },
    {
        tone: "instructor",
        label: __("Instructor", "antimanual"),
        description: __(
            "Adopt a tone like a course instructor or tutor. Explain concepts step by step, and guide the user as if teaching a class.",
            "antimanual"
        ),
    },
    {
        tone: "authoritative",
        label: __("Authoritative", "antimanual"),
        description: __(
            "Write confidently and with authority, as if the content is an official source. Avoid uncertainty or casual language.",
            "antimanual"
        ),
    },
    {
        tone: "enthusiastic",
        label: __("Enthusiastic", "antimanual"),
        description: __(
            "Use energetic and upbeat language. Make the topic sound exciting and engaging while still being informative.",
            "antimanual"
        ),
    },
    {
        tone: "minimalist",
        label: __("Minimalist", "antimanual"),
        description: __(
            "Use short, to-the-point sentences. Focus only on what's necessary. Avoid fluff or long explanations.",
            "antimanual"
        ),
    },
    {
        tone: "support agent",
        label: __("Support Agent", "antimanual"),
        description: __(
            "Write like a helpful customer support agent. Be polite, solution-focused, and empathetic. Assume you're responding to user confusion.",
            "antimanual"
        ),
    },
    {
        tone: "blog-style",
        label: __("Blog Style", "antimanual"),
        description: __(
            "Use an informal blog-post tone. Include personal touches, first-person references, and make the writing feel more human and story-like.",
            "antimanual"
        ),
    },
];
